
import { Button, Dialog } from 'element-ui';
import cartMixin from '@/mixins/cartMixin.js';
import {
  loadFbSdk,
  getFbLoginStatus,
  fbLogout,
} from '/plugins/facebookLogin/helpers.js';
import CustomerService from '@/services/CustomerService';

export default {
  components: {
    Button,
    Dialog,
  },
  mixins: [cartMixin],
  data() {
    return {
      countdown: 10,
      countdownInterval: null,
      customerService: new CustomerService({
        http: this.$http,
        auth: this.$auth,
        store: this.$store,
      }),
    };
  },
  computed: {
    showed: {
      get() {
        return this.$store.state.shared.wind.expiredModal;
      },
      set(val) {
        this.$store.commit('shared/wind/toggleExpiredModal', val);
      },
    },
  },
  methods: {
    closeDialog() {
      this.showed = false;
      this.stopCountdown();
      this.logout();
    },
    startCountdown() {
      this.countdownInterval = setInterval(() => {
        this.countdown--;
        if (this.countdown <= 0) {
          this.closeDialog();
        }
      }, 1000);
    },
    stopCountdown() {
      if (this.countdownInterval) {
        clearInterval(this.countdownInterval);
        this.countdownInterval = null;
      }
    },
    async logout() {
      try {
        const faceboookStatusConnected = await getFbLoginStatus();
        if (faceboookStatusConnected.status === 'connected') {
          await loadFbSdk(process.env.FACEBOOK_APP_ID, 'v2.10');
          await fbLogout();
        }
      } catch {}

      this.$store.commit('cart/clear', this.$auth);

      this.cartService.clearCart();

      this.$store.dispatch('user/guest/setGuestUser', {
        user: null,
        cookies: this.$cookies,
      });

      this.$store.commit('favorite/clear', this.$auth);
      this.$store.commit('shop/tunnel/address/clearStore', this.$auth);

      await this.$auth.logout();
      this.customerService.logOut();
      this.$router.replace(
        this.localePath({
          name: 'authenticate-route',
          params: { route: 'login' },
        })
      );
    },
  },
  mounted() {
    // let userGuest = this.$store.state.user.guest.guestUser;
    // this.showed =
    //   this.$auth.loggedIn &&
    //   !userGuest &&
    //   this.$auth.strategy.token.status().expired();
    // if (this.showed) {
    //   this.startCountdown();
    // }
  },

  watch: {
    showed(val) {
      if (val) {
        this.startCountdown();
      }
    },
  },

  beforeDestroy() {
    this.stopCountdown();
  },
};
